var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.customStyle)},[_vm._t("minusSign"),(_vm.position === 0)?[_vm._t("symbol"),_vm._t("amount")]:[_vm._t("amount"),_vm._t("symbol")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }